import { Item } from "@/@types/cart";
import { Promotion, Ticket } from "@/@types/workshop";




export function currentPriceFormat(ticket: Ticket, installments?: number) {
  const promotion = findPromotion(ticket)

  const currentPrice = promotion ? promotion.price_cents : ticket.promotions[ticket.promotions.length - 1].price_cents;

  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(installments ? (currentPrice / 100) / installments : currentPrice / 100);
}

export function currentPrice(ticket: Ticket): number {
  const promotion = ticket.promotions.find(
    (promotion) =>
      new Date(promotion.start_date) <= new Date() &&
      new Date(promotion.end_date) >= new Date(),
  );

  return (promotion ? promotion.price_cents : ticket.promotions[ticket.promotions.length - 1].price_cents) / 100;
}

export function formatPrice(price: number) {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(price);
}

export function calculateTotalPrice(item: Item) {
  const ticket = item.ticket;
  const promotion = findPromotion(ticket);

  let currentPrice = promotion ? promotion.price_cents : ticket.promotions[ticket.promotions.length - 1].price_cents;
  currentPrice = currentPrice * item.quantity

  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(currentPrice / 100);
}

export function findPromotion(ticket: Ticket): Promotion | undefined {
  return ticket.promotions.find(
    (promotion) =>
      new Date(promotion.start_date) <= new Date() &&
      new Date(promotion.end_date) >= new Date(),
  );
}


export function currency(value: string): string {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  })
    .format(parseFloat(value.replace(/[^0-9]/g, '')) / 100 || 0)
    .replace('R$', '')
    .trim()
}


export function shouldShowPromotion(ticket: Ticket) {
  const promotion = findPromotion(ticket);

  if (!promotion) return null

  return promotion.price_cents !== ticket.promotions[ticket.promotions.length - 1].price_cents ? ticket.promotions[ticket.promotions.length - 1].price_cents : null
}

export function centsToDecimalString(cents: number): string {
  return (cents / 100).toFixed(2)
}
